module.exports = __webpack_public_path__ + "static/media/CaretDown.3129023b.svg";